import Vue from "vue";
import "@/assets/css/tailwind.css";
import VueRouter from "vue-router";
import App from "./App.vue";
import { router } from "./router";
import { store } from "./store/store";
import "@/plugins/lucide-icons";
import indexDbHelper from "@/helpers/indexDbHelper";

// Import UI Components
import { Modal, Button, Alert } from "@/components/ui";

// Register UI Components Globally
Vue.component("Modal", Modal);
Vue.component("Button", Button);
Vue.component("Alert", Alert);

// Enable Vue DevTools
Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.use(VueRouter);

// Initialize IndexedDB
indexDbHelper.initialize();

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
